import {  
  loadUserDataInProgress,
  loadUserDataSuccess,
  loadUserDataFailure,
  // closeUserDialog,
  userOperationCompleted,
  loadUserRoleDataSuccess,
  loadAppUserDataSuccess,
  loadUserPermissionsDataSuccess
} from "../state/user/actions";
import { oktaAuth } from '../auth/okta';
import { errorSweetAlert, oopsSweetAlert } from '../components/SweetAlertMessages';
import swal from 'sweetalert';
const serverBasePath=process.env.REACT_APP_SERVER_API_URL;

let abortController = null;

export const loadUserList = (userType,searchText,page=0,pageSize=10) => async (dispatch) => {

  const token = oktaAuth.getAccessToken();
  if (!token) throw new Error('No access token');
  if (abortController) {
    abortController.abort();
  }
  abortController = new AbortController();
  const signal = abortController.signal;
  try {
    dispatch(loadUserDataInProgress());
    const response = await fetch(serverBasePath+"/user/getUsers?userType="+userType+"&searchText="+searchText+"&page="+page+"&pageSize="+pageSize,
    {
      signal,
      method: "GET",    
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
      },
    });

    const result = await response.json();
    dispatch(userOperationCompleted());
    if(response.status !==  200){
      oopsSweetAlert(result);
      return;
    } 
    dispatch(loadUserDataSuccess(result));
  } catch (e) {
    dispatch(loadUserDataFailure());
    if (e.name === "AbortError") {
      //errorSweetAlert({message:'The operation was aborted.'}); 
    }
  }
};


export const addNewUser = (data,userType,page) => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  dispatch(loadUserDataInProgress());
  try {
      const response = await fetch(serverBasePath+"/user/addNewUser", 
      {
          method: "POST",  
          headers: {
            Authorization: 'Bearer ' + token,       
            'Content-Type': 'application/json',
          },
          body:JSON.stringify(data)
      });
      const result = await response.json();
      dispatch(userOperationCompleted());
      if(response.status !== 200){
          oopsSweetAlert(result);
          return;
      }
      //dispatch(closeUserDialog());
      swal({
          title: "Success",
          text: result.message,
          icon: "success",
          closeOnClickOutside:false,
          closeOnEsc: false,
          allowOutsideClick: false,
      }).then(marked => {
        if (marked) {
          dispatch(loadAppUserList(userType,'',page));
        }
      });
  } catch (e) {
      dispatch(loadUserDataFailure());
      errorSweetAlert(e);
  }
};



export const importUsers = (data,userType,page) => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  dispatch(loadUserDataInProgress());
  try {
      let info = {
        'users'     : data,
        'userType'  : userType
      }
      const response = await fetch(serverBasePath+"/user/importUsers", 
      {
          method: "POST",  
          headers: {
            Authorization: 'Bearer ' + token,       
            'Content-Type': 'application/json',
          },
          body:JSON.stringify(info)
      });
      const result = await response.json();
      dispatch(userOperationCompleted());
      if(response.status !== 200){
          oopsSweetAlert(result);
          return;
      }
      //dispatch(closeUserDialog());
      swal({
          title: "Success",
          text: result.message,
          icon: "success",
          closeOnClickOutside:false,
          closeOnEsc: false,
          allowOutsideClick: false,
      }).then(marked => {
        if (marked) {
          dispatch(loadAppUserList(userType,'',page));  
        }
      });
  } catch (e) {
      dispatch(loadUserDataFailure());
      errorSweetAlert(e);
  }
};


export const loadRoleList = () => async (dispatch) => {
  const token = oktaAuth.getAccessToken();
  if (!token) throw new Error('No access token');
  try {
    dispatch(loadUserDataInProgress());
    const response = await fetch(serverBasePath+"/user/roles",
    {
      method: "GET",    
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
      }
    });
    const result = await response.json();
    dispatch(userOperationCompleted());
    if(response.status !==  200){
        oopsSweetAlert(result);
        return;
    } 
    dispatch(loadUserRoleDataSuccess(result));
  } catch (e) {
    dispatch(loadUserDataFailure());
    if (e.name === "AbortError") {
      //errorSweetAlert({message:'The operation was aborted.'}); 
    } 
  }
};

export const deleteUser = (userType,userId,page) =>  {
  return async (dispatch) => {
      const token = oktaAuth.getAccessToken();
      if (!token) throw new Error('No access token');
      try {
          dispatch(loadUserDataInProgress());
          const response = await fetch(process.env.REACT_APP_SERVER_API_URL+"/user/delete/"+userId,
          {
            method: "PUT",
            headers: {
              Authorization: 'Bearer ' + token,
              'Content-Type': 'application/json',
            }
          });
          const result = await response.json();
          dispatch(userOperationCompleted());
          if(response.status !==  200){
              oopsSweetAlert(result);
              return;
          }
          swal({
              title: "Success",
              text: result.message,
              icon: "success",
              closeOnClickOutside:false,
              closeOnEsc: false,
              allowOutsideClick: false,
          })
          .then(marked => {
              if (marked) {
                  //dispatch(loadUserList(userType,'',page))
                if(userType === 1){
                  dispatch(loadUserList(userType,'',page))
                } else {
                  dispatch(loadAppUserList(userType,'',page))
                }
              }
          });
      } catch (e) {   
          dispatch(loadUserDataFailure());
          errorSweetAlert(e); 
      }
  };
};



export const updateUserStatus = (userType,userStatus,userId,page) =>  {
  return async (dispatch) => {
      const token = oktaAuth.getAccessToken();
      if (!token) throw new Error('No access token');
      try {
          dispatch(loadUserDataInProgress());
          const response = await fetch(process.env.REACT_APP_SERVER_API_URL+"/user/"+userId+"/status/"+userStatus,
          {
            method: "PUT",
            headers: {
              Authorization: 'Bearer ' + token,
              'Content-Type': 'application/json',
            }
          });
          const result = await response.json();
          dispatch(userOperationCompleted());
          if(response.status !==  200){
              oopsSweetAlert(result);
              return;
          }
          swal({
              title: "Success",
              text: result.message,
              icon: "success",
              closeOnClickOutside:false,
              closeOnEsc: false,
              allowOutsideClick: false,
          })
          .then(marked => {
              if (marked) {
                  //dispatch(loadUserList(userType,'',page))
                  if(userType === 1){
                    dispatch(loadUserList(userType,'',page))
                  } else {
                    dispatch(loadAppUserList(userType,'',page))
                  }
              }
          });
      } catch (e) {   
          dispatch(loadUserDataFailure());
          errorSweetAlert(e); 
      }
  };
};



export const loadUserPermissionsList = (userId) => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  try {
    dispatch(loadUserDataInProgress());
    const response = await fetch(serverBasePath+"/user/permission/"+userId,{
      method: "GET",
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
      }
    });
    const data = await response.json();
    dispatch(userOperationCompleted()); 
    if(response.status !== 200){
      swal("Error", data?.error?.message, "error");
      return;
    }
    dispatch(loadUserPermissionsDataSuccess(data));
    // dispatch(loadDataSuccess(data));
  } catch (e) {       
    dispatch(loadUserDataFailure());
    errorSweetAlert(e);
  }
};


export const updateUserPermissions = (userId,permissions) => async (dispatch) => {
  const token = oktaAuth.getAccessToken();
  if (!token) throw new Error('No access token');
  let data = {
    'userId' : userId,
    'permissions' : permissions
  }
  dispatch(loadUserDataInProgress());
  try {
      const response = await fetch(serverBasePath+"/user/updatepermissions", 
      {
          method: "PUT",  
          headers: {
            Authorization: 'Bearer ' + token,       
            'Content-Type': 'application/json',
          },
          body:JSON.stringify(data)
      });
      const result = await response.json();
      dispatch(userOperationCompleted());
      if(response.status !== 200){
          oopsSweetAlert(result);
          return;
      }
      swal("Success", result.message, "success");
  } catch (e) {
      dispatch(loadUserDataFailure());
      errorSweetAlert(e);
  }
};

export const updateUserRole = (roleId,id,userType,page) => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  try {
    dispatch(loadUserDataInProgress());
    const body = JSON.stringify({roleId:roleId, userId:id,userType:userType });
    const response = await fetch(serverBasePath+"/user/role", 
    {
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
      },
      method: "put",
      body,
    });
    const result = await response.json();
    dispatch(userOperationCompleted());
    if(response.status !==  200){
        dispatch(loadUserDataFailure('error in api'));
        oopsSweetAlert(result);
        return;
    } 
    swal({
      title: "Success",
      text: result.message,
      icon: "success",
      closeOnClickOutside:false,
      closeOnEsc: false,
      allowOutsideClick: false,
  })
  .then(marked => {
      if (marked) {
        //dispatch(reLoadUserData());
        if(userType === 1){
          dispatch(loadUserList(userType,'',page))
        } else {
          dispatch(loadAppUserList(userType,'',page))
        }
        swal({
          title: "Warning",
          text: "User access has changed and any passwords generated previously will not work with the new access level. Hence they need to regenerate them.",
          icon: "warning",
          closeOnClickOutside:false,
          closeOnEsc: false,
          allowOutsideClick: false,
        });  
      }
  });
} catch (e) {
  dispatch(loadUserDataFailure(e));
  errorSweetAlert(e); 
}
};

export const loadAppUserList = (userType,searchText,page=0,pageSize=10) => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  if (abortController) {
    abortController.abort();
  }
  abortController = new AbortController();
  const signal = abortController.signal;
  try {
    dispatch(loadUserDataInProgress());
    const response = await fetch(serverBasePath+"/user/getUsers?userType="+userType+"&searchText="+searchText+"&page="+page+"&pageSize="+pageSize,
    {
      signal,
      method: "GET",    
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
      }
    });
    const result = await response.json();
    dispatch(userOperationCompleted());
    if(response.status !==  200){
        oopsSweetAlert(result);
        return;
    } 
    dispatch(loadAppUserDataSuccess(result));
  } catch (e) {
    dispatch(loadUserDataFailure());
    if (e.name === "AbortError") {
      //errorSweetAlert({message:'The operation was aborted.'}); 
    }
  }
};

export const updateUserEndDate = (userType,userId,endDate,page) =>  {
  return async (dispatch) => {
      const token = oktaAuth.getAccessToken();
      if (!token) throw new Error('No access token');
      try {
          let data = {};
          data.userId = userId;
          data.endDate = endDate;
          dispatch(loadUserDataInProgress());
          const response = await fetch(process.env.REACT_APP_SERVER_API_URL+"/user/updateUserEndDate",
          {
            method: "PUT",
            headers: {
              Authorization: 'Bearer ' + token,
              'Content-Type': 'application/json',
            },
            body:JSON.stringify(data)
          });
          const result = await response.json();
          dispatch(userOperationCompleted()); 
          if(response.status !==  200){
              oopsSweetAlert(result);
              return;
          }
          swal({
              title: "Success",
              text: result.message,
              icon: "success",
              closeOnClickOutside:false,
              closeOnEsc: false,
              allowOutsideClick: false,
          })
          .then(marked => {
              if (marked) {
                  //dispatch(loadUserList(userType,'',page))
                  if(userType === 1){
                    dispatch(loadUserList(userType,'',page))
                  } else {
                    dispatch(loadAppUserList(userType,'',page))
                  }
              }
          });
      } catch (e) {   
          dispatch(loadUserDataFailure());
          errorSweetAlert(e); 
      }
  };
};
